import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { Observable } from 'rxjs';

export enum EStrategy {
  'onEnter' = 'onEnter',
  'onBlur' = 'onBlur',
  'onSearchIconClick' = 'onSearchIconClick',
  'normal' = 'normal'
}

export enum EFilterType {
  'dateRange' = 'dateRange',
  'select' = 'select',
  'text' = 'text'
}

export interface IFilterBaseOption {
  type: EFilterType;
  key: string;
  disabled?: boolean | (() => boolean);
  visible?: boolean | (() => boolean);
}

export interface IFilterTextOption extends IFilterBaseOption {
  type: EFilterType.text;
  placeholder: string;
}

export interface IFilterSelectOption extends IFilterBaseOption {
  type: EFilterType.select;
  title: string;
  placeholder?: string;
  options: IFilterSelectOptionOptions | Observable<IFilterSelectOptionOptions>;
  multiple?: boolean;
  serverSearch?: boolean;
  onSearch?: (value: NzSafeAny) => void;
  onChange?: (value: NzSafeAny) => void;
}

export type IFilterSelectOptionOptions = { value: NzSafeAny; label: string }[];

export interface IFilterDateRangeOption extends IFilterBaseOption {
  type: EFilterType.dateRange;
  title: string;
  format?: string;
  showTime?: boolean | (() => boolean);
  showToday?: boolean | (() => boolean);
}

export interface IFilterSearchSelectGetListOption {
  label: string;
  value: NzSafeAny;
}

export type IFilterOptions = (IFilterTextOption | IFilterSelectOption | IFilterDateRangeOption)[];

export type IFilterKeywordPlacement = 'inner' | 'outer' | 'both';

export interface IFilterParams {
  [key: string]: string | undefined | string[] | [Date | null, Date | null];
}

export type IFilterValue = string | string[] | [Date, Date];

export interface IFilterCol {
  name: string;
  key: string;
  keyAlias?: string;
  visible?: boolean;
  disabled?: boolean;
  filterOptions?: Partial<IFilterCol>;
  [key: string]: NzSafeAny;
}
